import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private originalUrl: string = '';

  setOriginalUrl(url: any): void {
    this.originalUrl = url;
  }

  getOriginalUrl(): string {
    return this.originalUrl;
  }
}